import { useEffect, useState } from 'react'
import UniversalCookie from 'universal-cookie'
import usePageContext from '../Page/context'
import { usePathname } from 'next/navigation'
import { ILanguage } from '../../../types/ILanguage'
import { useCookies } from 'react-cookie'

const useHeader = () => {
  const [, setCookie] = useCookies(['awardsLocale'])
  const Cookies = new UniversalCookie()
  const locale: ILanguage = Cookies.get('awardsLocale') || 'en'

  // used to avoid SSR hydration problem
  const [showLangSelector, setShowLangSelector] = useState(false)

  useEffect(
    () => {
      setShowLangSelector(true)
    },
    [locale]
  )

  const [scrolledFurtherDown, setScrolledFurtherDown] = useState(false)
  const [initialHash, setInitialHash] = useState<string | null>(null)
  const [checkInitialHash, setCheckInitialHash] = useState(false)
  // const [headerHeight, setHeaderHeight] = useState(0)
  const headerHeight = 100 // Set a fixed height for the header
  const [scrolled, setScrolled] = useState(false)
  const pathname = usePathname()
  // Extra amount to scroll before hiding the menu entirely
  const extraScroll = 600

  // Theme
  const {
    state: { theme, labelsData }, dispatch
  } = usePageContext()

  const [screenSize, setScreenSize] = useState<number>(0)

  // Check current slide and apply the theme
  useEffect(() => {
    const sections = document.querySelectorAll('.snap-section-start')
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // debugger
          if (entry.target.classList.contains('theme-transparent')) {
            dispatch({
              type: 'SET_THEME',
              payload: 'transparent'
            })
          }

          if (entry.target.classList.contains('theme-black')) {
            dispatch({
              type: 'SET_THEME',
              payload: 'black'
            })
          }

          if (entry.target.classList.contains('hide-floating-logos')) {
            dispatch({
              type: 'SET_FLOATING_LOGOS_VISIBLE',
              payload: false
            })
          }

          if (entry.target.classList.contains('show-floating-logos')) {
            dispatch({
              type: 'SET_FLOATING_LOGOS_VISIBLE',
              payload: true
            })
          }
        }
      })
    }, {
      threshold: 0.1 // Fully in view
    })
    sections.forEach(section => observer.observe(section))
    // Reevaluate also on screensize change
  }, [dispatch, screenSize, pathname])

  // Reevaluate the theme changes every time screen size change
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Call handleResize immediately to set initial state
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Logic to hide/show navbar based on scroll direction
  useEffect(() => {
    // sticky header
    let isScrolling: NodeJS.Timeout
    let lastScrollY = window.pageYOffset

    const onListenScroll = () => {
      const scrollY = window.pageYOffset
      const direction = scrollY > lastScrollY ? 'down' : 'up'
      const currentHash = document.location.hash

      //  On initial load, if scrolling up hide navbar
      if (
        initialHash &&
        direction === 'up' &&
        checkInitialHash &&
        initialHash === currentHash &&
        scrollY > headerHeight
      ) {
        window.clearTimeout(isScrolling)

        isScrolling = setTimeout(() => {
          setScrolled(true)
          setCheckInitialHash(false)
        }, 100)

        return
      }

      // If switching to new anchor and scrolling up, hide navbqr
      if (currentHash && direction === 'up' && !!initialHash && initialHash !== currentHash) {
        window.clearTimeout(isScrolling)

        isScrolling = setTimeout(() => {
          setScrolled(true)
          setInitialHash(currentHash)
        }, 100)

        return
      }

      if (direction === 'down' && scrollY > headerHeight) {
        setScrolled(true)
      } else if (direction === 'up' || scrollY < headerHeight || (lastScrollY === 0 && scrollY > headerHeight)) {
        setScrolled(false)
      }

      if (currentHash) setInitialHash(currentHash)

      // Additional condition for scrolledFurtherDown
      if (direction === 'down' && scrollY > headerHeight + extraScroll) {
        setScrolledFurtherDown(true)
      } else {
        setScrolledFurtherDown(false)
      }

      lastScrollY = scrollY > 0 ? scrollY : 0
    }

    window.addEventListener('scroll', onListenScroll)
    return () => {
      window.removeEventListener('scroll', onListenScroll)
    }
  }, [checkInitialHash, initialHash])
  const navBarAnimation = {
    transform: `translateY(${scrolledFurtherDown ? headerHeight * -1 : scrolled ? headerHeight * -1 : 0}px)`,
    transitionDuration: '500ms'
  }


  const langs = [
    {
      label: 'EN',
      value: 'en'
    },
    {
      label: 'FR',
      value: 'fr'
    }
  ]

  return {
    navBarAnimation,
    scrolled,
    setScrolled,
    setCheckInitialHash,
    setInitialHash,
    setScrolledFurtherDown,
    theme,
    pathname,
    locale,
    setCookie,
    navbarData: labelsData?.Navbar || {},
    langs,
    showLangSelector
  }
}

export default useHeader
